import React from 'react';
import PropTypes from 'prop-types';
import Item from './components/Item';
import classes from './index.scss';
import { renderIf } from 'modules/render-if';
import classNames from 'classnames';

const Checklist = (props) => {
  const checklistClass = classNames({
    [props.className]: typeof props.className === "string",
  });

  return (
    <div className={ checklistClass } >
      {renderIf(props.title)(() => (
        <div className={ classes.title }>
          { props.title }
        </div>
      ))}
      <ul className={ classes.list }>
        {props.items.map((item, idx) => {
          return <Item
            key={ idx }
            text={ item.text }
            useBullet={ props.useBullet }
            valid={ item.valid }
          />;
        })}
      </ul>
    </div>
  )
};

Checklist.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    valid: PropTypes.bool.isRequired,
  }).isRequired).isRequired,
  title: PropTypes.string,
  useBullet: PropTypes.bool.isRequired,
};

export default Checklist;
